"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _LocalStorageHelper = require("./utils/LocalStorageHelper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var selectors = Object.freeze({
	bookmakerRow: ".RC-oddsRaceContent__data_offer",
	bookie: ".PC-bestOdds__bookieRow_betslip",
	choseBookie: ".js-RC-chooseBookieMobile__bookmaker"
});

var attributes = Object.freeze({
	bookmakerName: "bookmaker-name",
	bookieName: "data-diffusion-bookiename",
	dataHidden: "data-hidden",
	dataBookmakerName: "data-bookmaker-name"
});

var bookmakersTierOne = ["williamhill", "ladbrokes", "bet365", "coral", "paddypower", "betfair", "skybet", "tote"];

/**
 * Filters out bookmakers that the user has either:
 * - Marked as having an account with during the bookmaker quiz
 * - Recently logged into
 *
 * @param {HTMLElement} $offers
 * @returns Object
 */
var getBookmakersToExclude = function getBookmakersToExclude($offers, dataAttribute) {
	var userTraits = (0, _LocalStorageHelper.tryParseJson)((0, _LocalStorageHelper.getLocalStorageItem)("__user_traits") || "{}");
	var recentBookmaker = (0, _LocalStorageHelper.tryParseJson)((0, _LocalStorageHelper.getLocalStorageItem)("recentBookmakers") || "{}");

	var excludedBookmakers = [].concat(_toConsumableArray(Object.keys(userTraits).filter(function (key) {
		return Boolean(userTraits[key]);
	})), _toConsumableArray(Object.keys(recentBookmaker))).reduce(function (acc, cur) {
		return cur.includes("_quiz") ? acc.add(cur.replace(/(_quiz)/g, "").replaceAll("_", "").toLowerCase()) : acc.add(cur);
	}, new Set());

	return $offers.filter(function (_idx, offer) {
		var bookmakerName = (0, _jquery2.default)(offer).attr(dataAttribute).toLowerCase().replaceAll(" ", "");

		return bookmakersTierOne.includes(bookmakerName) && excludedBookmakers.has(bookmakerName);
	});
};

/**
 * Map and validate by offer which should be excluded and hidden
 *
 * @param {Object} offers
 */
var handleExcludedOffers = function handleExcludedOffers(offers) {
	return offers.each(function (_idx, offer) {
		return (0, _jquery2.default)(offer).attr(attributes.dataHidden, "true");
	});
};

var BookmakersHandler = function () {
	function BookmakersHandler() {
		_classCallCheck(this, BookmakersHandler);

		this.$body = (0, _jquery2.default)("body");

		this.$bookmakerOffers = this.$body.find(selectors.bookmakerRow);
		this.$bookies = this.$body.find(selectors.bookie);
		this.$choseBookies = this.$body.find(selectors.choseBookie);

		this.init();
	}

	_createClass(BookmakersHandler, [{
		key: "init",
		value: function init() {
			this.oddsComparisonHandler();
			this.bookiesHandler();
			this.chooseBookiesHandler();
		}

		/**
   * Hide "New Account Bet Offer" on hover if user is logged in into the bookmaker
   * or has marked the bookmaker as having an account with during the bookmaker quiz
   *
   */

	}, {
		key: "oddsComparisonHandler",
		value: function oddsComparisonHandler() {
			var $offersToExlude = getBookmakersToExclude(this.$bookmakerOffers, attributes.bookmakerName);

			handleExcludedOffers($offersToExlude);
		}

		/**
   * Hide "Open account" in the odds if user is logged in into the bookmaker
   * or has marked the bookmaker as having an account with during the bookmaker quiz
   *
   */

	}, {
		key: "bookiesHandler",
		value: function bookiesHandler() {
			var $bookiesToExlude = getBookmakersToExclude(this.$bookies, attributes.bookieName);

			handleExcludedOffers($bookiesToExlude);
		}

		/**
   * Hide "Choose your Bookmaker" bookmakers if user is logged in into the bookmaker
   * or has marked the bookmaker as having an account with during the bookmaker quiz
   *
   */

	}, {
		key: "chooseBookiesHandler",
		value: function chooseBookiesHandler() {
			var $choseBookiesToExclude = getBookmakersToExclude(this.$choseBookies, attributes.dataBookmakerName);

			handleExcludedOffers($choseBookiesToExclude);
		}
	}]);

	return BookmakersHandler;
}();

exports.default = BookmakersHandler;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/BookmakersHandler.js
// module id = 2691
// module chunks = 0